import { render, staticRenderFns } from "./preset_fiters.vue?vue&type=template&id=5613698f&lang=pug&"
import script from "./preset_fiters.vue?vue&type=script&setup=true&lang=js&"
export * from "./preset_fiters.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports